import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import Topbar from '../../components/Bar/Topbar'
import Header from '../../components/Bar/Header'
import Footer from '../../components/Footer/Footer'
import MainContainer3 from '../../components/Carousel/MainContainer3'
import BannerArea3 from '../../components/Carousel/BannerArea3'
import ServiceGrid from '../../components/Sections/ServiceGrid'

const Services = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: 'easeOut' }}
    >
   
      <Header />
    
 <div style={{marginTop:'160px'}}>
      <ServiceGrid />
 </div>
      <Footer />
    </motion.div>
  )
}

export default Services
